import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
export function mapSelected(selected) {
  var finalArray = [];
  var makes = selected.filter(function (child) {
    return (child === null || child === void 0 ? void 0 : child.filterField) === "make_id";
  });
  var models = selected.filter(function (child) {
    return (child === null || child === void 0 ? void 0 : child.filterField) === "model_id";
  });
  var extins = selected.filter(function (child) {
    return (child === null || child === void 0 ? void 0 : child.filterField) === "trim_id";
  });
  var otherFacets = selected.filter(function (child) {
    return (child === null || child === void 0 ? void 0 : child.filterField) !== "make_id" && (child === null || child === void 0 ? void 0 : child.filterField) !== "model_id" && (child === null || child === void 0 ? void 0 : child.filterField) !== "trim_id" && (child === null || child === void 0 ? void 0 : child.show) != false;
  });
  extins.forEach(function (ext) {
    var extMakeId = ext.parent_ids[1]; // ! will be parent_idss
    var extModelId = ext.parent_ids[0];
    var model = models.find(function (mod) {
      return mod.id === extModelId;
    });
    var make = makes.find(function (mak) {
      return mak.id === extMakeId;
    });
    if (!finalArray.some(function (item) {
      return item.id === (make === null || make === void 0 ? void 0 : make.id) && item.filterField === (make === null || make === void 0 ? void 0 : make.filterField);
    })) finalArray.push(make);
    if (!finalArray.some(function (item) {
      return item.id === (model === null || model === void 0 ? void 0 : model.id) && (item === null || item === void 0 ? void 0 : item.filterField) === (model === null || model === void 0 ? void 0 : model.filterField);
    })) finalArray.push(model);
    finalArray.push(ext);
  });
  models.forEach(function (model) {
    var modelMakeId = model.parent_ids[0];
    var make = makes.find(function (mak) {
      return mak.id === modelMakeId;
    });
    if (!finalArray.some(function (item) {
      return item.id === make.id && (item === null || item === void 0 ? void 0 : item.filterField) === (make === null || make === void 0 ? void 0 : make.filterField);
    })) finalArray.push(make);
    if (!finalArray.some(function (item) {
      return item.id === model.id && (item === null || item === void 0 ? void 0 : item.filterField) === (model === null || model === void 0 ? void 0 : model.filterField);
    })) finalArray.push(model);
  });
  makes.forEach(function (make) {
    if (!finalArray.some(function (item) {
      return item && make && item.id === make.id && item.filterField === make.filterField;
    })) finalArray.push(make);
  });
  return [].concat(finalArray, _toConsumableArray(otherFacets));
}
export var isRangeFilter = function isRangeFilter(filterName) {
  var rangeFilters = ["year", "odometer", "sellingprice", "monthly_installment"];
  return rangeFilters.includes(filterName);
};
export var prepareDeletedFilters = function prepareDeletedFilters(filter, selectedOptions) {
  var isRange = isRangeFilter(filter === null || filter === void 0 ? void 0 : filter.filterField);
  var IsMake = (filter === null || filter === void 0 ? void 0 : filter.filterField) === "make_id";
  var IsModel = (filter === null || filter === void 0 ? void 0 : filter.filterField) === "model_id";
  if (isRange) {
    return selectedOptions.filter(function (option) {
      return (option === null || option === void 0 ? void 0 : option.filterField) !== (filter === null || filter === void 0 ? void 0 : filter.filterField);
    });
  }
  if (IsMake) {
    return selectedOptions.filter(function (option) {
      var isDeletedMake = (option === null || option === void 0 ? void 0 : option.filterField) === "make_id" && option.id === filter.id;
      var isMakeModel = (option === null || option === void 0 ? void 0 : option.filterField) === "model_id" && filter.id === option.parent_ids[0];
      var isMakeTrim = (option === null || option === void 0 ? void 0 : option.filterField) === "trim_id" && filter.id === option.parent_ids[1];
      return !isDeletedMake && !isMakeModel && !isMakeTrim;
    });
  }
  if (IsModel) {
    return selectedOptions.filter(function (option) {
      var isDeletedModel = (option === null || option === void 0 ? void 0 : option.filterField) === "model_id" && option.id === filter.id;
      var isModelTrim = (option === null || option === void 0 ? void 0 : option.filterField) === "trim_id" && filter.id === option.parent_ids[0];
      return !isDeletedModel && !isModelTrim;
    });
  }
  return selectedOptions.filter(function (option) {
    var isDeletedFilter = (option === null || option === void 0 ? void 0 : option.filterField) === (filter === null || filter === void 0 ? void 0 : filter.filterField) && option.id === filter.id;
    return !isDeletedFilter;
  });
};
export function validateFilters(arr) {
  // Create a set of unique parent IDs in the array
  var makesIds = new Set(arr.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.filterField) === "make_id";
  }).map(function (item) {
    return item.id;
  }));
  var modelsIds = new Set(arr.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.filterField) === "model_id";
  }).map(function (item) {
    return item.id;
  }));

  // Filter the array to include only objects with valid parent IDs
  var filteredArray = arr.filter(function (item) {
    if ((item === null || item === void 0 ? void 0 : item.filterField) === "model_id") {
      return makesIds.has(item.parent_ids[0]);
    }
    if ((item === null || item === void 0 ? void 0 : item.filterField) === "trim_id") {
      return makesIds.has(item.parent_ids[1]);
    }
    return true;
  });
  return filteredArray;
}